/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import Day from '../day'
import * as styles from '../../date.pickers.styl'
import { DayOptions } from '../../models'

export interface WeekdaysProps {
  days: DayOptions[]
  month: number
}

export const getKey = (month: number, dayName: string, index: number) =>
  `${index}_${month}${dayName}`

export const Weekdays: React.FC<WeekdaysProps> = ({
  days = [],
  month
}: WeekdaysProps) => (
  <div className={styles.weekdays} role="week-days">
    {days.map((day, index) => (
      <Day
        date={day?.date}
        key={getKey(month, day?.dayLabel, index)}
        day={day?.dayLabel}
      />
    ))}
  </div>
)
